import React from 'react';

import { useClientOnly } from '@hooks/useClientOnly';
import { MessagingLastMessageProps } from './types';
import { default as ProfileIcon } from '@assets/icons/placeholder-profile.svg?react';
import Loading from "@ui/Loading";;

import scss from './MessagingLastMessage.module.scss';
import { useLastMessage } from './hooks';

const MessagingLastMessage = ({ appKey, userId, channelUrl, regularUpdate, setUnreadStatus }: MessagingLastMessageProps) => {
    const {lastMessage, messageSender, isUnread} = useLastMessage({ appKey, userId, channelUrl, regularUpdate, setUnreadStatus });
    const isClient = useClientOnly();
    if(!isClient) return null;

    const element = (lastMessage == null 
        ? <Loading /> 
        : <div className={'card-body p-2'}>
            {!messageSender?.isCurrentUser &&
                <div className={`mb-2 ${scss.messageHeader}`}>
                    {
                        !!messageSender?.profileUrl
                        ? <img className={scss.profileImageSmall} src={messageSender?.profileUrl} alt={messageSender?.nickname} />
                        : <ProfileIcon className={scss.profileSvg} />
                    }
                    <strong>{messageSender?.nickname}</strong>
                </div>
            }
            <div className='card bg-transparent border-0'>
                <div className={`card-body border-0 rounded-3 ${scss.messageBubble} ${!!messageSender?.isCurrentUser ? scss.outgoing : (isUnread ? scss.unread : '')}`}>
                    <div className={`${scss.messageText} ${lastMessage.type == 'image' ? 'h-100' : ''}`}>
                        {(() => {
                            switch(lastMessage.type) {
                                case 'image':
                                    return <img src={lastMessage.url ?? ''} alt={lastMessage.message} className={scss.messageImage} />;
                                case 'file':
                                    return <div className={scss.messageFile}>
                                                <div className={scss.messageFileIconContainer}><i className='far fa-file-lines'></i></div>
                                                <div>{lastMessage.message}</div>
                                            </div>;
                                default:
                                    return lastMessage.message;
                            }
                        })()}
                    </div>
                </div>
            </div>
            {!!messageSender?.isCurrentUser &&
                <div className={`mt-1 me-1 ${scss.messageHeader} ${scss.outgoingHeader}`}>
                    {
                        !!messageSender?.profileUrl
                        ? <img className={scss.profileImageSmall} src={messageSender?.profileUrl} alt={messageSender?.nickname} />
                        : <ProfileIcon className={scss.profileSvg} />
                    }
                    <strong>{messageSender?.nickname}</strong>
                </div>
            }
        </div>
    );

    return element;
}

export default MessagingLastMessage;
